import { FILTER_CUSTOM_ID } from '@/constants';

export const reportsTrainingSummary = {
    namespaced: true,

    state: {
        filter: {
            clubId: FILTER_CUSTOM_ID,
            athletes: [],
            tags: [],
            speedIntensities: [],
            hrIntensities: [],
            srIntensities: [],
            focuses: []
        }
    },

    getters: {
        getFilter(state) {
            return state.filter;
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter.clubId = FILTER_CUSTOM_ID;
            state.filter.athletes = [];
            state.filter.tags = [];
            state.filter.speedIntensities = [];
            state.filter.hrIntensities = [];
            state.filter.srIntensities = [];
            state.filter.focuses = [];
        },

        setAthletes(state, payload) {
            state.filter.athletes = payload;
        },

        setTags(state, payload) {
            state.filter.tags = payload;
        },

        setSpeedIntensity(state, payload) {
            state.filter.speedIntensities = payload;
        },

        setHrIntensity(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setSrIntensity(state, payload) {
            state.filter.srIntensities = payload;
        },

        setFocus(state, payload) {
            state.filter.focuses = payload;
        },

        setClubId(state, payload) {
            state.filter.clubId = payload;
        }
    }
};

export default reportsTrainingSummary;
